import styled from "styled-components";

export const BaseButton = styled.button`
  width: 100%;
  min-height: 48px;
  padding: 0 1.5rem;
  font-family: "poppins-medium", sans-serif;
  font-size: 0.95rem;
  letter-spacing: 0.02rem;
  color: #fff;
  background: var(--grad);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  box-shadow: var(--glow);
  transition: transform 0.3s var(--ease), filter 0.3s var(--ease);

  &:hover {
    transform: translateY(-2px);
    filter: brightness(1.08);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const GoogleSignInButton = styled(BaseButton)`
  background: rgba(255, 255, 255, 0.04);
  color: var(--text);
  border: 1px solid var(--border-strong);
  box-shadow: none;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: var(--accent);
    filter: none;
  }
`;

export const InvertedButton = styled(BaseButton)`
  background: transparent;
  color: var(--text);
  border: 1px solid var(--border-strong);
  box-shadow: none;

  &:hover {
    border-color: var(--accent);
    color: var(--accent);
    background: transparent;
    filter: none;
  }
`;
